// DS: DS4.6
import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import IconWrap from '../IconWrap';
const ThemeSwitchLight = (props)=>/*#__PURE__*/ React.createElement(IconWrap, _extends({
        disableDefaultColors: true
    }, props), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32"
    }, /*#__PURE__*/ React.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#EAEAEA",
        d: "M16 27c6.075 0 11-4.925 11-11S22.075 5 16 5 5 9.925 5 16s4.925 11 11 11z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#161A1F",
        fillRule: "evenodd",
        d: "M23.864 23.692l-4.47-3.52-2.66 2.444 3.808 3.406a11.025 11.025 0 003.322-2.33zm-4.613 2.82A10.996 10.996 0 0116 27c-4.246 0-7.93-2.405-9.764-5.927L9.84 18l9.412 8.512z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#161A1F",
        d: "M15.56 16.99c1.415 0 2.56-1.117 2.56-2.495 0-1.378-1.145-2.495-2.56-2.495S13 13.117 13 14.495c0 1.378 1.146 2.495 2.56 2.495z"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#B1B1B9",
        d: "M27.5 16c0 6.351-5.149 11.5-11.5 11.5S4.5 22.351 4.5 16 9.649 4.5 16 4.5 27.5 9.649 27.5 16z"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: "16",
        cy: "16",
        r: "14",
        stroke: "transparent",
        strokeWidth: "2"
    }))));
ThemeSwitchLight.displayName = 'ThemeSwitchLight';
export default ThemeSwitchLight;
